module.exports = __webpack_public_path__ + "img/v30.eb306f99.jpg";